import image1  from "../assets/icons/1.png"
import image2  from "../assets/icons/2.png"
import image3  from "../assets/icons/3.png"


export const member = [
    {
        title: "Community",
        subject: "KMA members have opportunities  for networking, skill development, and staying updated on industry trends. ",
        image:image1,
        color:"#F4F2FF"
    },
    {
        title: "Networking",
        subject: "Management networking can  provide opportunities for professional growth, knowledge sharing, and building valuable relationships",
        image:image2,
        color:"#FFFEFE"
    },
    {
        title: "Learning",
        subject: "Learning new things  can lead to personal growth, increased understanding and knowledge, and improved job performance and career advancement",
        image:image3,
        color:"#F4F2FF"
    },
]